export class FacetValue {
	public constructor(public readonly identity: string, public readonly count: number) {}
}
